/* unplugin-vue-components disabled */import script from "./QueryOrganizationNum.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryOrganizationNum.vue?vue&type=script&setup=true&lang=js"

import "./QueryOrganizationNum.vue?vue&type=style&index=0&id=0f9310ac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f9310ac"]])

export default __exports__